import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PolicyOrganizationIcon = props => (
  <Icon viewBox="0 0 2480 2475" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-962 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M2655.94 998.482 2208.12 833.547C2202.9 831.613 2197.1 831.613 2191.88 833.547L1744.06 998.482C1734.78 1001.96 1728.59 1010.66 1728.59 1020.53L1728.59 1185.46C1728.59 1198.42 1739.03 1209.05 1752.18 1209.05 1752.18 1209.05 1752.18 1209.05 1752.18 1209.05L1822.95 1209.05 1822.95 1588.62C1768.04 1599.83 1728.78 1648.17 1728.59 1704.05L1728.59 1798.41C1728.59 1811.37 1739.03 1822 1752.18 1822 1752.18 1822 1752.18 1822 1752.18 1822L2647.82 1822C2660.78 1822 2671.41 1811.56 2671.41 1798.41 2671.41 1798.41 2671.41 1798.41 2671.41 1798.41L2671.41 1704.05C2671.41 1647.98 2631.96 1599.83 2577.05 1588.62L2577.05 1209.05 2647.82 1209.05C2660.78 1209.05 2671.41 1198.61 2671.41 1185.46 2671.41 1185.46 2671.41 1185.46 2671.41 1185.46L2671.41 1020.53C2671.41 1010.66 2665.22 1001.77 2655.94 998.482ZM2624.23 1704.05 2624.23 1774.82 1775.77 1774.82 1775.77 1704.05C1775.77 1664.99 1807.48 1633.47 1846.54 1633.28L2553.65 1633.28C2592.71 1633.47 2624.23 1665.19 2624.23 1704.05ZM1869.94 1586.29 1869.94 1209.05 2011.28 1209.05 2011.28 1586.29 1869.94 1586.29ZM2058.65 1586.29 2058.65 1209.05 2341.54 1209.05 2341.54 1586.29 2058.65 1586.29ZM2388.53 1586.29 2388.53 1209.05 2529.87 1209.05 2529.87 1586.29 2388.53 1586.29ZM2624.23 1162.06 1775.77 1162.06 1775.77 1036.96 2200 880.726 2624.23 1036.96 2624.23 1162.06Z"
                stroke="currentColor"
                strokeWidth="27.5"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1375.5 2206.88 1375.5 268.125C1375.5 233.952 1403.2 206.25 1437.37 206.25L2638.94 206.25C2655.34 206.25 2671.08 212.769 2682.68 224.373L3007.38 549.064C3018.98 560.669 3025.5 576.407 3025.5 592.817L3025.5 2206.88C3025.5 2241.05 2997.8 2268.75 2963.62 2268.75L1437.37 2268.75C1403.2 2268.75 1375.5 2241.05 1375.5 2206.88Z"
                stroke="currentColor"
                strokeWidth="68.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M2613 556.875 2613 242.71C2613 222.574 2629.32 206.25 2649.46 206.25 2659.13 206.25 2668.4 210.091 2675.25 216.929L3014.82 556.509C3021.66 563.346 3025.5 572.62 3025.5 582.29 3025.5 602.426 3009.18 618.75 2989.03 618.75L2674.87 618.75C2640.7 618.75 2613 591.048 2613 556.875Z"
                stroke="currentColor"
                strokeWidth="68.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
